const utf8bom = [0xef, 0xbb, 0xbf];
const sampleCsvFileName = "sample.csv";

export { utf8bom, sampleCsvFileName };
